import React from 'react';
import RadioBox from 'epic-diesel-form/src/components/form/RadioBox';
import {useGetMessages} from '../../../../hooks';

//@ts-ignore
import styles from './LegalAcknowledgementSection.pcss';

interface Props {
    trigger: (k, v) => void;
    age18Acknowledgment: boolean;
    guardianAcknowledgment: boolean;
}

const LegalAcknowledgementSection: React.FC<Props> = ({
    age18Acknowledgment,
    guardianAcknowledgment,
    trigger
}) => {
    const messages = useGetMessages({
        header: 'epic.affiliate.signup.legal.header',
        text: 'epic.affiliate.signup.legal.text.v2',
        textSub: 'epic.affiliate.signup.legal.text.sub.v2',
        adult: 'epic.affiliate.signup.legal.acknowledge18.v2',
        guardian: 'epic.affiliate.signup.legal.guardian.v2',
        required: 'errors.com.epicgames.validation.required_field.v2'
    });

    return (
        <>
            <h2>
                {messages.header} {' *'}
            </h2>
            <p>{`${messages.text} ${messages.textSub}`}</p>

            <div className={styles.acknowledge}>
                <RadioBox name="ageAcknowledgment" value={age18Acknowledgment} onChange={trigger}>
                    {messages.adult}
                </RadioBox>
                <RadioBox
                    name="guardianAcknowledgment"
                    validations={guardianAcknowledgment || age18Acknowledgment ? null : 'checked'}
                    validationError={messages.required}
                    value={guardianAcknowledgment}
                    onChange={trigger}>
                    {messages.guardian}
                </RadioBox>
            </div>
        </>
    );
};

export default React.memo(LegalAcknowledgementSection);
